import React, { useState, useEffect, useContext } from "react";
import Table from "../Homepage/Table";
import "../../css_files/Master/CustomerPricingMaster.css";
import AddCustomerPricingMaster from "./AddCustomerPricing";
import SearchCustomerPricingMaster from "./SearchCustomerPricingMaster";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import getCookie from "../../api";
import { triggerscroll } from "../Homepage/Homepage";
import AddMaster from "./AddMaster";
import SearchMaster from "./SearchMaster";
import axiosInstance from "../../api";

function CustomerPricingMaster() {
  const [showaddform, setshowaddform] = useState(false);
  const [showsearchform, setshowsearchform] = useState(false);
  const tablehead = ["Id", "Code", "Percentage", "Description"];
  const [tabledata, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [triggerupdate, settriggerupdate] = useState(false);
  const [customerpricingupdatedata, setcustomerpricingupdatedata] =
    useState(null);
  const [datareload, setdatareload] = useState(0);
  const [loading, setloading] = useState(false);
  const { setExpiredSession, permissionsdata, userData } =
    useContext(triggerscroll);
  const [filterbutton, setfilterbutton] = useState(false);
  const [activatedfilters, setactivatedfilters] = useState([]);
  const [excelloading, setexcelloading] = useState(false);

  function setsearchedtabledata(tabledata) {
    setTableData(
      tabledata.map((x) => [x.id, x.code, x.percentage, x.description])
    );
  }

  function fetchcustomerpricingdata(customerpricingid) {
    setcustomerpricingupdatedata(null);
    const url = `${process.env.REACT_APP_API_URL}/api/v1/CustomerPricing/GetCustomerPricingByIdOrCodeOrPercentage?id=${customerpricingid}`;
    axiosInstance
      .get(url)
      .then((res) => {
        setcustomerpricingupdatedata(res.data[0]);
      })
      .catch(console.log);
  }

  useEffect(() => {
    setloading(true);
    const URL = `${process.env.REACT_APP_API_URL}/api/v1/CustomerPricing`;
    axiosInstance
      .get(URL)
      .then((response) => {
        setTableData(
          response.data.map((x) => [x.id, x.code, x.percentage, x.description])
        );
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [reload]);

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Customer Pricing" &&
        x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Customer Pricing" &&
        x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Customer Pricing" &&
        x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Master" &&
        x.subHead === "Customer Pricing" &&
        x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <section className="customer-pricing-master">
      <h1>Customer Pricing Master</h1>
      <blockquote className="customer-pricing-master-forms">
        <AddMaster
          text="Add Customer Pricing Master"
          setshowaddform={setshowaddform}
          settriggerupdate={settriggerupdate}
          setshowsearchform={setshowsearchform}
          permit={writePermission}
        />

        <SearchMaster
          text="Search Customer Pricing Master"
          setshowsearchform={setshowsearchform}
          setshowaddform={setshowaddform}
        />
      </blockquote>
      {showaddform && (
        <AddCustomerPricingMaster
          setshowaddform={setshowaddform}
          reload={reload}
          setReload={setReload}
          triggerupdate={triggerupdate}
          customerpricingupdatedata={customerpricingupdatedata}
          key={`${customerpricingupdatedata?.id}-${triggerupdate}-${datareload}`}
        />
      )}
      {showsearchform && (
        <SearchCustomerPricingMaster
          setshowsearchform={setshowsearchform}
          setsearchedtabledata={setsearchedtabledata}
          setReload={setReload}
          reload={reload}
        />
      )}
      <Table
        tablehead={tablehead}
        tabledata={tabledata}
        setshowaddform={setshowaddform}
        settriggerupdate={settriggerupdate}
        fetchdata={fetchcustomerpricingdata}
        url="CustomerPricing/DeleteCustomerPricing"
        reload={reload}
        setReload={setReload}
        setdatareload={setdatareload}
        datareload={datareload}
        loading={loading}
        setshowsearchform={setshowsearchform}
        readPermission={readPermission}
        updatePermission={updatePermission}
        deletePermission={deletePermission}
      />
    </section>
  );
}

export default CustomerPricingMaster;
